import React, { Component } from 'react'
import LoadingOverlay from 'react-loading-overlay';

import Store from '../store/Store';

class LoadingIndicator extends Component {
    render() {
		const { active, children } = this.props;

		const getStore = Store.getState();
        return (
			<LoadingOverlay
				active={active}
				spinner={<i className="fa fa-spinner fa-spin" style={{"fontSize":"50px"}}></i>}
				text={getStore.survey.surveyList.splashMessage}
				fadeSpeed={getStore.survey.surveyList.splashMessageMinTime}
			>
				{children}
			</LoadingOverlay>
        )
    }
}

export default LoadingIndicator;